export const PageHeader = ({ overline, title, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div className="fade-up">
      {overline && <p className="mb-1 text-xs font-bold uppercase tracking-[0.18em] text-orange-600">{overline}</p>}
      <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);
